import { useEffect } from 'react'


const ResetPluckingRooster = () => {

    const Reset = async () => {
        try {
            localStorage.removeItem('rooster_played')

            //window.location.href = 'https://adsl.mx/rooster?utm_source=rooster_web&utm_medium=resend_page&utm_campaign=fcm_doradosfc'
            window.location.href = '/rooster?utm_source=rooster_web&utm_medium=resend_page&utm_campaign=fcm_doradosfc'
        } catch (error) {
            
        }
    }

    const GoToGame = async () => {
        try {
            await Reset()
        } catch (error) {
            
        }
    }

    useEffect(() => {
        Reset()
    },[])
    

    return (
        <>
            <div className="SelfieFan__Sent container">
                <img src="/img/page/adsl-five-bicolor.png" className="LogoADSLxZtudia mt-3" alt="Logo" />
                <p className='Messages__Fan__Text--Center'>Un momento... te estamos reenviando al juego</p>
                <p className='Messages__Fan__Text--Center'>Si no has sido reenviado en 3 segundos. Presiona el botón Reenviar al juego</p>
                <button type='button' className='Btn__Adsl--RedOutlineTransparent mx-auto' onClick={GoToGame}>Reenviar al juego</button>
                
                <hr />

                <a href='https://interaktia.com/?utm_source=rooster_web&utm_medium=resend_page&utm_campaign=fcm_doradosfc' target='_blank' rel="noreferrer" className='SelfieFan__Sent__Banner'>
                    <img src='/img/advertising/fdm/banner/five-digital-minds-agradecimiento.gif' alt='Publicidad' className='d-block m-auto SelfieFan__Sent__Banner__Image' />
                </a>
                <a href='https://interaktia.com/?utm_source=rooster_web&utm_medium=resend_page&utm_campaign=fcm_doradosfc' target='_blank' rel="noreferrer" className='Btn__Adsl--RedOutline m-auto text-decoration-none text-center d-block'>Contactar ahora</a>

                <hr />

                <p className='text-center mb-0'>¿Quieres conocer más de esta tecnología?</p>
                <p className='text-center mb-0'>Interaktia está listo para ti</p>
                <a href='https://interaktia.com/?utm_source=rooster_web&utm_medium=resend_page&utm_campaign=fcm_doradosfc' target='_blank' className='Btn__Adsl--RedOutline m-auto text-decoration-none text-center'>Contactar ahora</a>
            </div>

            <footer className="text-center mt-3 FooterCredits">
                Hecho con ♥ por <a href='https://interaktia.com/?utm_source=rooster_web&utm_medium=resend_page&utm_campaign=fcm_doradosfc' target='_blank' className='text-dark'>Interaktia</a> | 2026
            </footer>
        </>
    )
}

export { ResetPluckingRooster };